import { Expression } from "./abstract.expression";

export class SkipExpression extends Expression 
{
    constructor(private readonly value: number) 
    {
        super();
    }

    toQuery(): string 
    {
        return `$skip=${this.value}`;
    }
}
